import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import analyticsService from './services/analyticsService';
import './utils/analyticsDebug'; // Herramientas de debug (solo en desarrollo)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Inicializar servicio de analytics
analyticsService.init();

reportWebVitals();
